import { connect } from "react-redux";
import { providePopulateData } from "components/utility/hoc/PopulateData";

var SkillsetBanner = require("components/writing/questions/SkillsetBanner");
var AnswerWritingInterface = require("components/writing/answers/AnswerWritingInterface");

var CurrentUser = require("lib/account/CurrentUser");
var Spinner = require("components/utility/Spinner");
var Autosaver = require("components/writing/quizzes/Autosaver");

var WritingActions = require("lib/actions/WritingActions");
var WritingSelectors = require("lib/selectors/WritingSelectors");

var MyShelfRouting = require("lib/routing/MyShelfRouting");
var Glyphicon = require("components/utility/icons/Glyphicon");

require("writing/answers/new_essay_page.scss")

@connect(
    (state, props) => {
        var answerID = $wr.getURLParameterByName("answer_id");

        var downProps = {};

        if (!(WritingSelectors.isLoadingQuestions({ state }) ||
            WritingSelectors.isLoadingAnswers({ state, key: "index" }) ||
            WritingSelectors.isLoadingAnswers({ state, key: "create" }))) {

            if (answerID) {
                var answer = WritingSelectors.answer({
                    state, id: answerID
                });

            } else {
                var answer = WritingSelectors.essayAnswers({
                    state
                }).filter(x => x.draft || x.allow_revision)[0];
            }

            if (answer) {
                downProps.draftAnswer = answer;
                downProps.question = WritingSelectors.question({ state, id: answer.question_id });

            } else {
                downProps.questionOptions = WritingSelectors.mostRecentQuestions({
                    state, filters: { type: ESSAY_QUESTION }, count: QUESTION_OPTION_COUNT
                })
            }
        }

        return downProps;
    },
    (dispatch, props) => ({
        populateData: () => {
            function fetchEssayQuestions() {
                var conditions = { sample: 4 }
                var filters = { types: [ESSAY_QUESTION] }
                var embeds = ["question.meta"]

                return dispatch(WritingActions.fetchQuestions({ filters, conditions, embeds }))
            }

            // fetch draft essays
            function fetchDraft() {
                return dispatch(WritingActions.fetchEssayAnswers({
                    conditions: { userID: CurrentUser.get().id, draftOnly: true },
                    embeds: ["answer.question", "answer.meta_data", "answer.history", "question.meta"]
                })).then((response) => {
                    if (!_.size(response.answers)) {
                        fetchEssayQuestions()
                    }
                });
            }

            // if a specific answer_id is in the URL (e.g. revision), fetch it explicitly
            // since it won't be returned by draftOnly fetch
            var answerID = $wr.getURLParameterByName("answer_id");
            if (answerID) {
                var filters = { ids: [parseInt(answerID)] }
                var embeds = ["answer.question", "answer.gold_records", "answer.meta_data", "answer.evaluation", "question.answer_options", "evaluation.autograder_data"]
                dispatch(WritingActions.fetchAnswers({ filters, embeds }))
            }

            // fetch questions			
            return Promise.all([fetchDraft()]);
        },

        fetchEssayQuestions() {
            var conditions = { sample: 4 }
            var filters = { types: [ESSAY_QUESTION] }
            var embeds = ["question.meta"]

            return dispatch(WritingActions.fetchQuestions({ filters, conditions, embeds }))
        },

        createAnswer(questionID) {
            var answerData = {
                draft: true,
                question_id: questionID,
                answer_type: ESSAY_ANSWER
            };
            return dispatch(WritingActions.createAnswer({ answer: answerData }));
        },
        
        updateAnswer: (answerID, answerData) => {
            return dispatch(WritingActions.updateAnswer({ id: answerID, update: answerData }))
        },
        
        deleteAnswer: (answerID) => {
            return dispatch(WritingActions.deleteAnswer({ id: answerID }))
        },

        fetchAnswers: (answerIDs) => {
			var filters = { ids: answerIDs }
			var embeds = ["answer.question", "answer.gold_records", "answer.meta_data", "answer.evaluation", "question.answer_options", "evaluation.autograder_data"]
			return dispatch(WritingActions.fetchAnswers({ filters, embeds }))
		},
    })
)


@providePopulateData()
class NewEssayPage extends React.Component {
    constructor(props) {
        super();
        autobind(this);
        this.state = {
            autosaveLoading: false,
            questionChanged: false,
            loading: false,
            showConfirmDelete: false,
            selectedQuestionID: null,
        };
    }

    ///// HELPERS /////
    getStandard(question) {
        if (!question || !question.meta) { return false }

        if (_.includes(question.meta, INFORMATIONAL)) {
            return INFORMATIONAL
        } else if (_.includes(question.meta, NARRAITVE)) {
            return NARRAITVE
        } else {
            return PERSUASIVE
        }
    }

    ///// HANDLERS /////

    onQuestionSelect(question, e) {
        this.props.createAnswer(question.id);
    }

    onAnswerComplete() {
        var answerID = this.props.draftAnswer.id
        
        this.setState({ loading: true }, () => {
            this.saveAnswer(false).then(() => {
                var awardText =  "Great job on that essay"
                var completedTask = "answers"

                this.setState({ autosaveLoading: false });
                window.wrNotifications.triggerDropDownNotification({
                    title: "Done!", text: awardText, icon: "star"
                });
                CurrentUser.fetchCurrentUserCoinData();
                
                // load essay into redux store
                this.props.fetchAnswers([answerID]).then(() => {
                    $wr.redirect(MyShelfRouting.getPath({
                        activeView: MyShelfRouting.VIEWS.WORK_VIEW,
                        detailsView: 'essays'
                    }));
                })
            });
        });
    }

    autosaveDraft(callback) {
        this.setState({ autosaveLoading: true }, () => {
            this.saveAnswer(this.props.draftAnswer.draft).then(() => {
                this.setState({ autosaveLoading: false });
                if (callback) { callback(); }

            }).catch(() => {
                // Error Handling... allow future autosaving even if this one failed
                this.setState({ autosaveLoading: false });
                if (callback) { callback(); }
            });
        });
    }

    saveAnswer(draftStatus) {
        var answer = this.props.draftAnswer;

        if (answer.sessionMetaData) {
            if (_.isEmpty(answer.meta_data)) {
                // First time saving the answer; Make a new meta data array
                var metaData = [answer.sessionMetaData];
            } else {
                var metaData = _.clone(answer.meta_data);
                if (_.last(metaData).session_start != answer.sessionMetaData.session_start) {
                    // First time saving the answer this session, but was loaded from draft
                    // Push new meta data onto the array
                    metaData.push(answer.sessionMetaData);
                } else {
                    // Update this session's meta data
                    metaData[metaData.length - 1] = answer.sessionMetaData;
                }
            }
        }

        var answerData = {
            draft: draftStatus,
            parts: (answer.localParts || answer.parts),
            meta_data: metaData,
            history: answer.history,
        };

        if (!answer.allow_revision) {
            answerData.excluded = this.props.shouldExclude;
        }

        if (!draftStatus) {
            answerData.autograder_data = answer.recentAutograderData;
            answerData.allow_revision = false;
        }

        if (this.props.questionChanged) {
            answerData.question_id = this.props.question.id;
        }

        return this.props.updateAnswer(answer.id, answerData)
    }

    getAutosaveHash() {
        var answer = this.props.draftAnswer;

        if (answer) {
            var hashString = _.pluck(answer.localParts, "text").join("|");
            hashString += "|" + this.props.question.body;
            hashString += "|" + JSON.stringify(answer.sessionMetaData);
            hashString += "|" + JSON.stringify(answer.recentAutograderData);

            var hashValue = $wr.hashCode(hashString);

            return hashValue;
        }
    }

    showConfirmDelete() {
        if (confirm("If you delete this you will lose your work below. Are you sure?")) {
            this.deleteDraft(NewEssayPage.BACKTOQUESTIONS);
        }
    }

    deleteDraft(changeQuestion) {
        this.setState({ loading: true });
        this.props.deleteAnswer(this.props.draftAnswer.id).then(() => {
            this.setState({ loading: false });
            window.wrNotifications.triggerDropDownNotification({
                title: "Your work has been deleted!", text: "", icon: "trash"
            });

            if (changeQuestion == NewEssayPage.BACKTOQUESTIONS) {
                this.setState(this.initialStateData(), this.componentDidMount);
            } else {
                $wr.redirect("/");
            }
        })
    }

    changeQuestions(e) {
        $wr.nope(e)
        this.props.changeQuestion();
    }

    renderChooseQuestion() {        
        var title = "Choose Your Essay Prompt";
        var skillsetPreviews = _.map(this.props.questionOptions, (question) => {
            return (
                <SkillsetBanner skillset={this.getStandard(question)} key={question.id}
                    text={question.body} small={true} hideTitle={true}
                    onClick={this.onQuestionSelect.bind(this, question)} />
            );
        });

        var changeQuestionsLink = (
            <p className="changeQuestionsContainer">
                <a href="#" className="changeQuestionsLink"
                    onClick={this.props.fetchEssayQuestions}>Change Questions</a>
            </p>
        )

        return (
            <div>
                <header className="pageHeader">
                    <h1>{title}</h1>
                </header>
                {changeQuestionsLink}
                <div className="skillsetOptions">
                    {skillsetPreviews}
                </div>

            </div>
        );
    }

    renderWriteAnswer() {
        var { question } = this.props

        var backtoQuestionsContent = (
            <a href="#" key="confirm" onClick={this.showConfirmDelete}>
                <Glyphicon className='backArrow' icon="arrow-left" />
                Back to Questions
            </a>
        )

        return (
            <div>
                <SkillsetBanner skillset={this.getStandard(question)} />

                <div className="backToQuestionsContainer">
                    {backtoQuestionsContent}
                </div>

                <h3 className="textTitle">
                    {/* {this.props.book.title} */}
                </h3>

                <Autosaver onDeleteClick={this.deleteDraft}
                    autosaveLoading={this.state.loading || this.state.autosaveLoading}
                    getAutosaveHash={this.getAutosaveHash} onAutosave={this.autosaveDraft} />

                <AnswerWritingInterface
                    showAnswerLengthMeter={true}
                    loading={this.state.loading}
                    answerID={this.props.draftAnswer.id}
                    onComplete={this.onAnswerComplete}
                    questionIndex="solo" />

            </div>
        );
    }

    render() {
        if (this.state.loading) {
            var pageContent = (
                <div><Spinner placeholder={true} scale={1.7} /></div>
            );

        } else if (this.props.question && this.props.draftAnswer) {
            var pageContent = this.renderWriteAnswer();
        } else if (_.size(this.props.questionOptions)) {
            var pageContent = this.renderChooseQuestion();
        } else {
            var pageContent = (
                <div><Spinner placeholder={true} scale={1.7} /></div>
            );
        }

        return (
            <div className="container newEssayPage">
                {pageContent}
            </div>
        );
    }
};

var ESSAY_QUESTION = 'essay-question'
var ESSAY_ANSWER = 'essay-answer'

NewEssayPage.WrappedComponent.propTypes = PageStrictPropTypes({
    // Data from @connect
    book: PropTypes.object,
    question: PropTypes.object,
    draftRating: PropTypes.object,
    draftAnswer: PropTypes.object,
    questionOptions: PropTypes.array,
    isLoadingDraft: PropTypes.bool,
    shouldExclude: PropTypes.bool,
    onSelect: PropTypes.func,

    // Action hooks from @connect
    populateData: PropTypes.func.isRequired,
    changeQuestion: PropTypes.func,
    createAnswer: PropTypes.func,
    deleteAnswer: PropTypes.func,
    updateAnswer: PropTypes.func,
    createRating: PropTypes.func,
    updateRating: PropTypes.func,
    fetchReviewQuestion: PropTypes.func,
    fetchAnswerQuestions: PropTypes.func,
    fetchEssayQuestions: PropTypes.func,
    fetchAnswers: PropTypes.func,

});

NewEssayPage.BACKTOQUESTIONS = "backToQuestions"

var QUESTION_OPTION_COUNT = 4;
var INFORMATIONAL = 'skillset-informational'
var PERSUASIVE = 'skillset-persuasive'
var NARRAITVE = 'skillset-narrative'

module.exports = NewEssayPage;



// WEBPACK FOOTER //
// ./modules/components/writing/essays/NewEssayPage.js